import React from 'react';
import { Stack, FormControl, FormLabel, TextField, MenuItem, Box, Alert } from '@mui/material';

const Step1Form = ({ formData, handleChange }: { formData: any, handleChange: any }) => {
  const isNonKambing = formData.pilih_paket === 'nonkambing';

  return(
  <Stack spacing={2}>
      <FormControl fullWidth sx={{ textAlign: 'left' }}>
      <FormLabel htmlFor="niat" sx={{ textAlign: 'left' }}>Pilihan Niat</FormLabel>
      <TextField
        select
        value={formData.niat}
        onChange={handleChange}
        id="niat"
        name="niat"
        placeholder="Pilih Niat"
        autoFocus
        required
        fullWidth
        variant="outlined"
      >
        <MenuItem value="" disabled>Pilihan Niat</MenuItem>
        <MenuItem value="aqiqah">Aqiqah</MenuItem>
        <MenuItem value="peringatan">Peringatan/Tasyakuran</MenuItem>
      </TextField>
    </FormControl>

    {formData.niat === 'aqiqah' && (
    <FormControl>
      <FormLabel htmlFor="birth_place" sx={{ textAlign: 'left' }}>Tempat, Tgl Lahir</FormLabel>
      <TextField
        value={formData.birth_place}
        onChange={handleChange}
        id="birth_place"
        type="text"
        name="birth_place"
        placeholder="Masukan Tempat Tgl Lahir"
        autoFocus
        required={formData.niat === 'aqiqah'}
        fullWidth
        variant="outlined"
      />
                  <Alert severity="info" sx={{ mt: 1 }}>
              <strong>Tempat Tanggal Lahir</strong> bisa menyusul nanti.
            </Alert>

    </FormControl>

    )}

{formData.niat === 'peringatan' && (
    <FormControl fullWidth sx={{ textAlign: 'left' }}>
      <FormLabel htmlFor="pilih_paket" sx={{ textAlign: 'left' }}>Pilih Paket</FormLabel>
      <TextField
        select
        value={formData.pilih_paket}
        onChange={handleChange}
        id="pilih_paket"
        name="pilih_paket"
        placeholder="Pilih Paket"
        autoFocus
        required={formData.niat === 'aqiqah'}
        fullWidth
        variant="outlined"
      >
              <MenuItem value="" disabled>Pilih Paket</MenuItem>
              <MenuItem value="kambing">Kambing</MenuItem>
              <MenuItem value="nonkambing">Non Kambing</MenuItem>
      </TextField>
    </FormControl>
    )}



  {!isNonKambing &&(

  <>
      <FormControl>
      <FormLabel htmlFor="nameNiat" sx={{ textAlign: 'left' }}>Nama Lengkap (Bin/Binti) Nama Lengkap Ayah</FormLabel>
      <TextField
        value={formData.nameNiat}
        onChange={handleChange}
        id="nameNiat"
        type="text"
        name="nameNiat"
        placeholder="Contoh: Fulan Bin Fulan"
        autoFocus
        required
        fullWidth
        variant="outlined"
      />
            <Alert severity="info" sx={{ mt: 1 }}>
              <strong>Nama Peniatan</strong> bisa menyusul nanti.
            </Alert>
      
    </FormControl>

      <FormControl>
      <FormLabel htmlFor="namaPanggilan" sx={{ textAlign: 'left' }}>Nama Panggilan</FormLabel>
      <TextField
        value={formData.namaPanggilan}
        onChange={handleChange}
        id="namaPanggilan"
        type="text"
        name="namaPanggilan"
        placeholder="Masukan Nama Panggilan"
        autoFocus
        required
        fullWidth
        variant="outlined"
      />
            <Alert severity="info" sx={{ mt: 1 }}>
              <strong>Nama Panggilan</strong> bisa menyusul nanti.
            </Alert>
      
    </FormControl>

  <FormControl >
  <FormLabel htmlFor="data_kartu" sx={{ textAlign: 'left' }}>Data Kartu Ucapan</FormLabel>
  <Box width="100%">
    <TextField
      id="data_kartu"
      name="data_kartu"
      multiline
      maxRows={4}
      value={formData.data_kartu}
      onChange={handleChange}
      variant="outlined"
      placeholder="Nama Ayah dan Nama Ibu"
      fullWidth
    />
  </Box>
</FormControl>
    </>
        )}  
  </Stack>
);
};
export default Step1Form;